import { useState, useEffect } from 'react';
import { countries } from '../data/countries';
import guideData from '../guides';

const COUNTRY_COLORS = {
  germany:'#0891b2',   usa:'#dc2626',       uk:'#4f46e5',        canada:'#dc2626',
  australia:'#d97706', china:'#dc2626',      sweden:'#0891b2',    japan:'#dc2626',
  france:'#4f46e5',    italy:'#059669',      spain:'#d97706',     netherlands:'#d97706',
  denmark:'#dc2626',   norway:'#dc2626',     finland:'#0284c7',   switzerland:'#dc2626',
  austria:'#dc2626',   belgium:'#d97706',    hungary:'#059669',   poland:'#dc2626',
  portugal:'#059669',  ireland:'#059669',    turkey:'#dc2626',    malaysia:'#059669',
  india:'#d97706',     indonesia:'#dc2626',  southkorea:'#0284c7',russia:'#dc2626',
  saudiarabia:'#059669',singapore:'#dc2626', newzealand:'#4f46e5',pakistan:'#059669',
  romania:'#4f46e5',   qatar:'#7c3aed',      thailand:'#db2777',  uae:'#059669',
};

const getColor = (id) => COUNTRY_COLORS[id] || '#6366f1';

const TAG_COLORS = [
  { bg:'rgba(99,102,241,0.15)',  color:'#a5b4fc', border:'rgba(99,102,241,0.35)'  },
  { bg:'rgba(16,185,129,0.15)', color:'#6ee7b7', border:'rgba(16,185,129,0.35)'  },
  { bg:'rgba(245,158,11,0.15)', color:'#fcd34d', border:'rgba(245,158,11,0.35)'  },
  { bg:'rgba(14,165,233,0.15)', color:'#7dd3fc', border:'rgba(14,165,233,0.35)'  },
];

const globalStyle = `
  <style>
    .gc p      { margin-bottom:12px; color:#cbd5e1; font-size:15px; line-height:1.85; }
    .gc ul     { padding-left:22px; margin:10px 0 14px; }
    .gc ol     { padding-left:22px; margin:10px 0 14px; }
    .gc ul li  { margin-bottom:8px; color:#cbd5e1; line-height:1.7; font-size:15px; }
    .gc ol li  { margin-bottom:8px; color:#cbd5e1; line-height:1.7; font-size:15px; }
    .gc strong { color:#e2e8f0; font-weight:600; }
    .gc h4     { color:#a5b4fc; margin:16px 0 8px; font-size:15px; font-weight:700; }
  </style>
`;

const defaultGuide = (country) => ({
  name:    country ? country.name : 'Unknown',
  flag:    country ? country.flag : '🌍',
  tagline: `Complete study guide for ${country ? country.name : 'this country'} — coming soon`,
  sections: [
    { title:'1. Introduction',             content:'<p>Content coming soon!</p>' },
    { title:'2. Types of Study Options',   content:'<p>Content coming soon!</p>' },
    { title:'3. Universities and Fields',  content:'<p>Content coming soon!</p>' },
    { title:'4. Eligibility Requirements', content:'<p>Content coming soon!</p>' },
    { title:'5. Language Requirements',    content:'<p>Content coming soon!</p>' },
    { title:'6. Required Documents',       content:'<p>Content coming soon!</p>' },
    { title:'7. SOP and CV',              content:'<p>Content coming soon!</p>' },
    { title:'8. Scholarships',            content:'<p>Content coming soon!</p>' },
    { title:'9. Application Process',     content:'<p>Content coming soon!</p>' },
    { title:'10. Tuition Fees',           content:'<p>Content coming soon!</p>' },
    { title:'11. Living Costs',           content:'<p>Content coming soon!</p>' },
    { title:'12. Financial Proof',        content:'<p>Content coming soon!</p>' },
    { title:'13. Student Visa',           content:'<p>Content coming soon!</p>' },
    { title:'14. Student Life',           content:'<p>Content coming soon!</p>' },
    { title:'15. Career and PR',          content:'<p>Content coming soon!</p>' },
    { title:'16. Cost Summary',           content:'<p>Content coming soon!</p>' },
  ],
});

export default function StudyGuidePage({ setActivePage }) {
  const [selected,  setSelected]  = useState('germany');
  const [search,    setSearch]    = useState('');
  const [openIndex, setOpenIndex] = useState(0);
  const [guide,     setGuide]     = useState(null);
  const [loading,   setLoading]   = useState(false);

  const filtered    = countries.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));
  const accentColor = getColor(selected);

  useEffect(() => {
    const loadGuide = async () => {
      setLoading(true);
      setGuide(null);
      try {
        if (guideData[selected]) {
          const module = await guideData[selected]();
          setGuide(module.default?.sections
            ? module.default
            : defaultGuide(countries.find(c => c.id === selected))
          );
        } else {
          setGuide(defaultGuide(countries.find(c => c.id === selected)));
        }
      } catch {
        setGuide(defaultGuide(countries.find(c => c.id === selected)));
      }
      setLoading(false);
    };
    loadGuide();
  }, [selected]);

  const toggle              = (i)  => setOpenIndex(openIndex === i ? null : i);
  const handleCountrySelect = (id) => { setSelected(id); setOpenIndex(0); };

  if (!guide && !loading) return null;

  return (
    <div style={{display:'flex',minHeight:'calc(100vh - 68px)',background:'#060b14'}}>

      {/* ── SIDEBAR ── */}
      <div style={{width:'230px',background:'#080f1a',borderRight:'1px solid rgba(255,255,255,0.07)',display:'flex',flexDirection:'column',flexShrink:0,position:'sticky',top:'68px',height:'calc(100vh - 68px)'}}>

        <div style={{padding:'14px 14px 10px',borderBottom:'1px solid rgba(255,255,255,0.06)',flexShrink:0}}>
          <p style={{fontFamily:'Inter,sans-serif',fontSize:'10px',fontWeight:'700',color:'#475569',textTransform:'uppercase',letterSpacing:'1.5px',margin:'0 0 10px'}}>
            STUDY DESTINATIONS
          </p>
          <div style={{position:'relative'}}>
            <span style={{position:'absolute',left:'10px',top:'50%',transform:'translateY(-50%)',fontSize:'12px',color:'#475569',pointerEvents:'none'}}>🔍</span>
            <input
              placeholder="Search country..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{width:'100%',padding:'8px 8px 8px 28px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'9px',color:'#e2e8f0',fontFamily:'Inter,sans-serif',fontSize:'12px',outline:'none',boxSizing:'border-box'}}
              onFocus={e => e.target.style.borderColor='rgba(99,102,241,0.5)'}
              onBlur={e  => e.target.style.borderColor='rgba(255,255,255,0.1)'}
            />
          </div>
        </div>

        <div style={{overflowY:'auto',flex:1,padding:'6px 0'}}>
          {filtered.map(c => {
            const isActive = selected === c.id;
            const cc = getColor(c.id);
            return (
              <div
                key={c.id}
                onClick={() => handleCountrySelect(c.id)}
                style={{display:'flex',alignItems:'center',gap:'9px',padding:'9px 12px',cursor:'pointer',background:isActive?'rgba(99,102,241,0.12)':'transparent',borderLeft:isActive?`3px solid ${cc}`:'3px solid transparent',transition:'all 0.15s',marginBottom:'1px'}}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background='rgba(255,255,255,0.04)'; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.background='transparent'; }}
              >
                <div style={{width:'28px',height:'28px',borderRadius:'8px',background:isActive?`${cc}33`:'rgba(255,255,255,0.05)',border:isActive?`1px solid ${cc}55`:'1px solid rgba(255,255,255,0.08)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',flexShrink:0,transition:'all 0.15s'}}>
                  {c.flag}
                </div>
                <span style={{fontFamily:'Inter,sans-serif',fontSize:'12px',color:isActive?'#ffffff':'#cbd5e1',fontWeight:isActive?'700':'400',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                  {c.name}
                </span>
              </div>
            );
          })}
        </div>

        <div style={{padding:'10px 14px',borderTop:'1px solid rgba(255,255,255,0.06)',flexShrink:0}}>
          <span style={{fontFamily:'Inter,sans-serif',fontSize:'11px',color:'#334155'}}>{filtered.length} countries</span>
        </div>
      </div>

      {/* ── RIGHT CONTENT ── */}
      <div style={{flex:1,overflowY:'auto'}}>

        {loading && (
          <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%',flexDirection:'column',gap:'12px',minHeight:'400px'}}>
            <div style={{width:'32px',height:'32px',border:`3px solid ${accentColor}44`,borderTop:`3px solid ${accentColor}`,borderRadius:'50%',animation:'spin 0.8s linear infinite'}} />
            <style>{`@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}`}</style>
            <span style={{fontFamily:'Inter,sans-serif',fontSize:'14px',color:'#475569'}}>
              Loading {countries.find(c=>c.id===selected)?.name} guide...
            </span>
          </div>
        )}

        {!loading && guide && (
          <div style={{padding:'32px 44px'}}>

            {/* Header */}
            <div style={{marginBottom:'28px',paddingBottom:'24px',borderBottom:'1px solid rgba(255,255,255,0.07)'}}>
              <div style={{display:'flex',alignItems:'flex-start',gap:'16px',marginBottom:'16px'}}>
                <div style={{width:'56px',height:'56px',borderRadius:'14px',background:`linear-gradient(135deg, ${accentColor}33, ${accentColor}66)`,border:`1px solid ${accentColor}44`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'28px',flexShrink:0}}>
                  {guide.flag}
                </div>
                <div style={{flex:1}}>
                  <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'6px',flexWrap:'wrap'}}>
                    <h1 style={{fontFamily:'Space Grotesk,sans-serif',fontSize:'24px',fontWeight:'700',color:'#f1f5f9',margin:0,letterSpacing:'-0.5px'}}>
                      {guide.name} Study Guide
                    </h1>
                    <span style={{fontFamily:'Inter,sans-serif',fontSize:'11px',fontWeight:'700',background:`${accentColor}22`,color:accentColor,padding:'3px 10px',borderRadius:'20px',border:`1px solid ${accentColor}44`,whiteSpace:'nowrap'}}>
                      ● Complete Guide
                    </span>
                  </div>
                  <p style={{fontFamily:'Inter,sans-serif',fontSize:'13px',color:'#64748b',margin:0,lineHeight:1.6}}>
                    {guide.tagline}
                  </p>
                </div>
              </div>
              <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                {['Step by Step','Requirements','Scholarships','Visa Process'].map((tag,i) => (
                  <span key={tag} style={{fontFamily:'Inter,sans-serif',fontSize:'11px',fontWeight:'600',background:TAG_COLORS[i].bg,color:TAG_COLORS[i].color,border:`1px solid ${TAG_COLORS[i].border}`,padding:'4px 12px',borderRadius:'20px'}}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            {/* Accordion */}
            <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
              {guide.sections.map((sec, i) => {
                const isOpen = openIndex === i;
                return (
                  <div key={i} style={{background:isOpen?'#111827':'rgba(255,255,255,0.02)',borderRadius:'12px',border:`1px solid ${isOpen?accentColor:'rgba(255,255,255,0.08)'}`,overflow:'hidden',transition:'all 0.2s',boxShadow:isOpen?`0 0 0 1px ${accentColor}22`:'none'}}>
                    <div onClick={()=>toggle(i)} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'14px 18px',cursor:'pointer',userSelect:'none'}}>
                      <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                        <div style={{width:'8px',height:'8px',borderRadius:'50%',background:isOpen?accentColor:'rgba(255,255,255,0.2)',flexShrink:0,transition:'all 0.2s'}} />
                        <h3 style={{fontFamily:'DM Sans,sans-serif',fontSize:'14px',fontWeight:'700',color:isOpen?'#f1f5f9':'#cbd5e1',margin:0,transition:'color 0.2s'}}>
                          {sec.title}
                        </h3>
                      </div>
                      <div style={{width:'28px',height:'28px',borderRadius:'50%',background:isOpen?`${accentColor}33`:'rgba(255,255,255,0.05)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,transition:'all 0.2s'}}>
                        <span style={{color:isOpen?accentColor:'#475569',fontSize:'18px',lineHeight:'1',display:'block',transform:isOpen?'rotate(45deg)':'none',transition:'transform 0.2s',fontWeight:'300'}}>+</span>
                      </div>
                    </div>
                    {isOpen && (
                      <div style={{padding:'0 18px 18px 36px'}}>
                        <div style={{height:'1px',background:'rgba(255,255,255,0.06)',marginBottom:'14px'}} />
                        <div
                          style={{fontFamily:'Inter,sans-serif',fontSize:'15px',color:'#cbd5e1',lineHeight:'1.85',margin:0}}
                          dangerouslySetInnerHTML={{__html: globalStyle + '<div class="gc">' + sec.content + '</div>'}}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* CTA */}
            <div style={{marginTop:'28px',borderRadius:'16px',padding:'24px 28px',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'16px',background:`linear-gradient(135deg, ${accentColor}cc, ${accentColor}88)`,border:`1px solid ${accentColor}44`}}>
              <div>
                <h4 style={{fontFamily:'Manrope,sans-serif',fontSize:'16px',fontWeight:'700',color:'#fff',marginBottom:'5px'}}>
                  Need help studying in {guide.name}?
                </h4>
                <p style={{fontFamily:'Inter,sans-serif',fontSize:'13px',color:'rgba(255,255,255,0.8)',margin:0}}>
                  Our expert team has helped 1,000+ students get admitted worldwide 🎓
                </p>
              </div>
              <button
                onClick={() => setActivePage && setActivePage('experts')}
                style={{fontFamily:'Inter,sans-serif',fontSize:'14px',fontWeight:'700',background:'#fff',color:accentColor,border:'none',padding:'12px 24px',borderRadius:'10px',cursor:'pointer',whiteSpace:'nowrap'}}
                onMouseEnter={e => e.currentTarget.style.opacity='0.9'}
                onMouseLeave={e => e.currentTarget.style.opacity='1'}
              >
                Meet Our Experts →
              </button>
            </div>

            <div style={{height:'40px'}} />
          </div>
        )}
      </div>
    </div>
  );
}